import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import BlurLinearIcon from "@mui/icons-material/BlurLinear";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import Button from "@mui/material/Button";
import { unicodeToString } from "../../../Js/Common";
import ContextInfoModal from "../../../Components/Modal/ContextInfoModal";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { audioVideoSliceActions } from "../../../Store/Slices/AudioVideoSlice";
import "./style.css";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};
let audios = null;

const CI = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [currentWord, setCurrentWord] = useState(null);
  let [meaningModal, setMeaningModal] = useState(false);
  let [currentWordIndex, setCurrentWordIndex] = useState(0);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );

  const { audioPlaying } = useSelector((state) => state.audioVideo);

  useEffect(() => {
    if (!audioPlaying && audios) {
      audios.pause();
    }
  }, [audioPlaying]);

  useEffect(() => {
    if (props.content) {
      props.content.epage.options.content.map((val, ind) => {
        val.answer.map((innerVal, ind1) => {
          let id = `btn_${ind}_${ind1}`;
          if (document.getElementById(id)) {
            document.getElementById(id).addEventListener("click", () => {
              if (audios && !audios.paused) {
                return false;
              }
              setCurrentWord(document.getElementById(id).innerText);
              setCurrentWordIndex(ind1);
              if (val.words_audio[ind1]) {
                audios = new Audio(
                  `${sessionStorage.getItem('media_url')}audio/${val.words_audio[ind1]}`
                );
                console.log("audiosaudios", id);
                audios.onended = () => {
                  dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
                  if (
                    props.content?.epage?.options?.content[0]?.words_meaning[
                      currentWordIndex
                    ]
                  ) {
                    setMeaningModal(true);
                  }
                };
                if (audios && audios.paused) {
                  audios.play();
                  dispatch(audioVideoSliceActions.setAudioIsPlaying(true));
                  dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
                } else {
                  audios.pause();
                  dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
                }
              } else {
                if (
                  props.content?.epage?.options?.content[0]?.words_meaning[
                    currentWordIndex
                  ]
                ) {
                  setMeaningModal(true);
                }
              }
            });
          }
        });
      });

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
      });
    }

    return () => {
      if (audios) {
        audios.pause();
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      }
    };
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  return (
    <div>
      {props.content && (
        <Grid item xs={12} sx={{}}>
          <Box
            sx={{
              py: 2,
              mx: 6,
              mt: 1,
              height: "58vh",
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexFlow: "wrap",
                justifyContent: "center",
                px: 2,
                gap: 1,
              }}
            >
              {/* <Grid item xs={4} sx={{ textAlign: "center", mt: 3 }}>
            <CBTMedia />
          </Grid> */}
              <Grid item xs={11}>
                <Box
                   
                  sx={{
                    color: "#DB8829",
                    // textAlign: "justify",
                    boxShadow: 0,
                    height: "64vh",
                    overflow: "auto",
                    pl: 2,
                    pr: 2,
                  }}
                >
                  <div
                    className="macScreen"
                    style={{
                      fontSize: "1.3rem",
                      fontWeight: "500",
                      lineHeight: 2,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: unicodeToString(
                        props.content.epage.options.content[0].text
                      ),
                    }}
                  >
                    {/* Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>make</span> a type
                specimen book. It has survived not only five centuries, but also
                the leap into electronic typesetting, remaining essentially
                unchanged. It was popularised in the 1960s with the release of
                Letraset{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>
                  sheets containing
                </span>{" "}
                Lorem Ipsum passages, and more recently with desktop publishing
                software{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>like Aldus</span>{" "}
                PageMaker including versions of Lorem Ipsum, remaining
                essentially unchanged. It was{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>popularised</span> in
                the 1960s with the release of Letraset sheets containing Lorem
                Ipsum passages,{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>
                  and more recently
                </span>{" "}
                with desktop publishing software like Aldus PageMaker including
                versions of Lorem Ipsum,{" "}
                <span style={{ backgroundColor: "#DDDDDD" }}>
                  and more recently
                </span>{" "}
                with desktop publishing software like Aldus PageMaker including
                versions of Lorem Ipsum. */}
                    {/* {unicodeToString(
                      props.content.epage.options.content[0].text
                    )} */}
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <ContextInfoModal
            visible={meaningModal}
            audio={
              props.content.epage.options.content[0].meanings_audio
                ? props.content.epage.options.content[0].meanings_audio[
                    currentWordIndex
                  ]
                : null
            }
            meaning={
              props.content.epage.options.content[0].words_meaning
                ? props.content.epage.options.content[0].words_meaning[
                    currentWordIndex
                  ]
                : null
            }
            word={currentWord}
            toggleModal={(flag) => setMeaningModal(flag)}
          ></ContextInfoModal>
        </Grid>
      )}
    </div>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default CI;
